<!--
	作者：shujuan sun
	时间：2017-04-10
	描述：车辆状态图标
-->
<template>
	 <!--车辆监控页面_车辆状态解释开始-->
	<div class="icon_indicated picc_scene"> 
	  <ul>
	  	<li  class="li_text">现场：</li> 
	    <li class="bgc_04">
	    	<em>
	    		<input type="checkbox" v-model="rescueStatus1"/>
	    	</em>
	    	<span>待救援</span>
	    </li>
	    <li class="bgc_02">
	    	<em>
	    		<input type="checkbox" v-model="rescueStatus2"/>
	    	</em>
	    	<span>已派单</span>
	    </li> 
	    <li class="bgc_01">
	    	<em>
	    		<input type="checkbox" v-model="rescueStatus3"/>
	    	</em>
	    	<span>已完成</span>
	    </li>
	  </ul>
	</div>
	  <!--车辆监控页面_车辆状态解释结束-->
</template>
<script>
	import {mapState} from 'vuex'
	export default{
		name:'MenuStatusRescue',
		data(){
			return{
				rescueStatus1:true,
				rescueStatus2:false,
				rescueStatus3:false
			}
		},
		watch:{
			rescueStatus1(val){
				this.$emit('sceneOnMap1',val)
			},
			rescueStatus2(val){
				this.$emit('sceneOnMap2',val)
			},
			rescueStatus3(val){
				this.$emit('sceneOnMap3',val)
			}
		}
	}
</script>

<style scoped>
.icon_indicated{
	opacity: 1;
}
</style>


// WEBPACK FOOTER //
// MenuStatusRescue.vue?ca8a2f2c